export const colors = {
  black: '#000000',
  grey: '#707070',
  grey2: '#767676',
  grey3: '#C9C9C9',
  primary: '#FFD800',
  transparent: 'transparent',
  white: '#ffffff',
};
